var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetodos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 67.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tarjetas-de-credito"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_823",
    "data-name": "Grupo 823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_228",
    "data-name": "Trazado 228",
    className: "cls-1",
    d: "M68.06,19.37V39.1l3.34-.86.95,2.42a2.11,2.11,0,0,1-1,2.73L20.74,63.69a2,2,0,0,1-2.58-1.17h0l-1-2.43L56.43,44H28.15l-15,4.77L11.51,44H6.83l8,20.45A4.49,4.49,0,0,0,19,67.4a4.06,4.06,0,0,0,1.64-.35L73.24,44.77a4.72,4.72,0,0,0,2.41-6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.79,1.33A4.38,4.38,0,0,0,61.69,0H4.47A4.6,4.6,0,0,0,0,4.71V39.32a4.76,4.76,0,0,0,2.58,4.26A4.27,4.27,0,0,0,4.47,44H61.69a4.38,4.38,0,0,0,3.1-1.33,4.85,4.85,0,0,0,1.36-3.37V4.71A4.89,4.89,0,0,0,64.79,1.33ZM62,36a3.76,3.76,0,0,1-1.19,2.74,4,4,0,0,1-2.71,1.08h-50a4,4,0,0,1-1.65-.37A3.82,3.82,0,0,1,4.15,36V8A3.86,3.86,0,0,1,8.06,4.19h50a3.9,3.9,0,0,1,2.71,1.08A3.75,3.75,0,0,1,62,8Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodos);
export default __webpack_public_path__ + "static/media/Metodos.e1530366a6e84b11c0ca19c87457188a.svg";
export { ForwardRef as ReactComponent };